import { Component, OnInit } from '@angular/core';
import { WidgetBaseComponent } from '../../widget-base/widget-base.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-widget-image',
    imports: [CommonModule],
    templateUrl: './widget-image.component.html',
    styleUrls: ['./widget-image-base.component.scss']
})

export class WidgetImageBaseComponent extends WidgetBaseComponent implements OnInit {
  public imageUrl: string | undefined;
  public id: string | undefined;
  public cssClass: string | undefined;
  public imageDescription: string | undefined;
  public marginTop: string | undefined;
  public marginRight: string | undefined;
  public marginBottom: string | undefined;
  public marginLeft: string | undefined;

  public ngOnInit(): void {
    this.imageUrl = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("ImageUrl") == 0)?.value;
    this.id = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("Id") == 0)?.value;
    if (this.id && this.id.includes(' ')) {
      this.id = this.id.split(' ')[0];
    }
    this.cssClass = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("CssClass") == 0)?.value;
    this.imageDescription = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("ImageDescription") == 0)?.value;
    this.marginTop = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("MarginTop") == 0)?.value;
    this.marginRight = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("MarginRight") == 0)?.value;
    this.marginBottom = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("MarginBottom") == 0)?.value;
    this.marginLeft = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("MarginLeft") == 0)?.value;
  }

}
